<template>
  <div class="manager-field">
    <VSearchSelect
        class="manager-field__select"
        :placeholder="placeholder"
        :items="itemOptions"
        :error="props.error"
        @selectItem="onSelectResponsibleHr"
        @input="debouncedSearchResponsible"
        v-model="searchResponsibleHr"
    />
    <p class="manager-field__form-field-error"
       v-if="props.error">
      Заполните обязательное поле
    </p>
  </div>
</template>
<script setup>
import {computed, onMounted, ref} from "vue";
import {debounce} from "@/services/helpers";
import common from "@/api/common";
import externalIntegrations from "@/api/externalIntegrations";
const props = defineProps({
  modelValue: [String, Number],
  error: Boolean,
  placeholder: String,
})
const emit = defineEmits(["update:modelValue"]);
const searchResponsibleHr = ref('')
const responsibleHrOptions = ref([])

const debouncedSearchResponsible = debounce(() => searchResponsible(), 400);
const searchResponsible = async () => {
  if (!searchResponsibleHr.value) {
    emit('update:modelValue', null)
    searchResponsibleHr.value = '';
  }
};

const onSelectResponsibleHr = (item) => {
  emit('update:modelValue', item?.code)
  searchResponsibleHr.value = item?.name;
};

const itemOptions = computed(() => {
  return responsibleHrOptions.value.map((el) => {
    return ({...el, name: el.name})
  }).filter((item) =>
      item.name?.toLowerCase().includes(searchResponsibleHr.value?.toLowerCase())
  );
})

onMounted(async () => {
  const options = await common.getNationalities();
  if(options?.nationalities) {
    responsibleHrOptions.value = options?.nationalities
  }
  itemOptions.value.forEach((item) => {
    if (item?.id === props.modelValue || item?.code === props.modelValue) {
      searchResponsibleHr.value = item?.name;
    }
  })
})
</script>
<style scoped lang="scss">
.manager-field {
  &__select {
    width: 100%;
    min-height: 40px;

    :deep(.v-select__header) {
      height: 40px;
    }


    :deep(.v-select__header-value) {
      top: 12px;
      padding-right: 20px;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow-x: hidden;
      font-weight: 500;
    }
    :deep(.v-select__header_selected) {
      .v-select__header-palceholder {
        top: 2px;
        display: none;
      }
    }
  }

  &__form-field-error {
    margin-top: 16px;
    font-size: 14px;
    color: $red;
  }
}
</style>